/**
 * 加载高德地图API
 * @param key 高德地图的安全密钥
 * @returns Promise
 */
export function getAMap(key: string) {
  return new Promise(function (resolve, reject) {
    if (typeof window.AMap !== "undefined") {
      resolve(window.AMap)
      return true
    }
    // window.onAMapCallback = function () {
    //   resolve(window.AMap)
    // }
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src = "//webapi.amap.com/loader.js"
    script.onerror = reject
    script.onload = function () {
      console.log("高德地图API加载成功", AMapLoader)
      AMapLoader.load({
        key, //申请好的Web端开发者 Key，调用 load 时必填
        version: "2.0", //指定要加载的 JS API 的版本，缺省时默认为 1.4.15
      })
        .then(AMap => {
          resolve(AMap)
          window.AMap = AMap // 将AMap对象挂载到window上
          // const map = new AMap.Map("container")
        })
        .catch(e => {
          console.error(e) //加载错误提示
        })
    }
    document.head.appendChild(script)
  })
}

// 坐标转换工具函数
/**
 * 百度坐标（BD09）转高德坐标（GCJ02）
 * @param lng 百度坐标经度
 * @param lat 百度坐标纬度
 * @returns 高德坐标
 */
export function BD09toGCJ02(lng: number, lat: number) {
  const x_pi = (3.14159265358979324 * 3000.0) / 180.0
  const x = lng - 0.0065
  const y = lat - 0.006
  const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
  const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
  const gcjLng = z * Math.cos(theta)
  const gcjLat = z * Math.sin(theta)
  return { lng: gcjLng, lat: gcjLat }
}

/**
 * 高德坐标（GCJ02）转百度坐标（BD09）
 * @param lng 高德坐标经度
 * @param lat 高德坐标纬度
 * @returns 百度坐标
 */
export function GCJ02toBD09(lng: number, lat: number) {
  const x_pi = (3.14159265358979324 * 3000.0) / 180.0
  const x = lng
  const y = lat
  const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
  const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
  const bdLng = z * Math.cos(theta) + 0.0065
  const bdLat = z * Math.sin(theta) + 0.006
  return { lng: bdLng, lat: bdLat }
}

/**
 * WGS84坐标转高德坐标（GCJ02）
 * @param lng WGS84坐标经度
 * @param lat WGS84坐标纬度
 * @returns 高德坐标
 */
export function WGS84toGCJ02(lng: number, lat: number) {
  if (outOfChina(lng, lat)) {
    return { lng, lat }
  }

  let dLat = transformLat(lng - 105.0, lat - 35.0)
  let dLng = transformLng(lng - 105.0, lat - 35.0)
  const radLat = (lat / 180.0) * Math.PI
  let magic = Math.sin(radLat)
  magic = 1 - 0.00669342162296594323 * magic * magic
  const sqrtMagic = Math.sqrt(magic)
  dLat = (dLat * 180.0) / (((6378245.0 * (1 - 0.00669342162296594323)) / (magic * sqrtMagic)) * Math.PI)
  dLng = (dLng * 180.0) / ((6378245.0 / sqrtMagic) * Math.cos(radLat) * Math.PI)
  const gcjLat = lat + dLat
  const gcjLng = lng + dLng
  return { lng: gcjLng, lat: gcjLat }
}

/**
 * 判断坐标是否在中国境外
 * @param lng 经度
 * @param lat 纬度
 * @returns boolean
 */
function outOfChina(lng: number, lat: number) {
  return lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271
}

function transformLat(lng: number, lat: number) {
  let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
  ret += ((20.0 * Math.sin(6.0 * lng * Math.PI) + 20.0 * Math.sin(2.0 * lng * Math.PI)) * 2.0) / 3.0
  ret += ((20.0 * Math.sin(lat * Math.PI) + 40.0 * Math.sin((lat / 3.0) * Math.PI)) * 2.0) / 3.0
  ret += ((160.0 * Math.sin((lat / 12.0) * Math.PI) + 320 * Math.sin((lat * Math.PI) / 30.0)) * 2.0) / 3.0
  return ret
}

function transformLng(lng: number, lat: number) {
  let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
  ret += ((20.0 * Math.sin(6.0 * lng * Math.PI) + 20.0 * Math.sin(2.0 * lng * Math.PI)) * 2.0) / 3.0
  ret += ((20.0 * Math.sin(lng * Math.PI) + 40.0 * Math.sin((lng / 3.0) * Math.PI)) * 2.0) / 3.0
  ret += ((150.0 * Math.sin((lng / 12.0) * Math.PI) + 300.0 * Math.sin((lng / 30.0) * Math.PI)) * 2.0) / 3.0
  return ret
}

// 扩展全局Window接口以支持AMap
declare global {
  interface Window {
    AMap: any
    onAMapCallback: () => void
  }
}
